import React, { FC } from "react"
import { graphql } from "gatsby"

import { ContentBlockFragmentFragment } from "@graphqlTypes"

import Content from "@components/Content/Content"
import LpSection from "@components/lp/LpSection/LpSection"

import "./ContentBlock.scss"

const ContentBlock: FC<ContentBlockFragmentFragment> = ({
  content,
  contentful_id,
  marginBottom,
}) => {
  return (
    <LpSection
      className="ContentBlock"
      marginBottom={marginBottom}
      uniqueId={contentful_id}
    >
      <div className="container">
        <Content content={content} />
      </div>
    </LpSection>
  )
}

export const ContentBlockFragment = graphql`
  fragment ContentBlockFragment on ContentfulLpContentBlock {
    contentful_id
    content {
      raw
      references {
        ...PostContentReferencesFragment
      }
    }
    marginBottom
  }
`

export default ContentBlock
